/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
const convertCurrentDateobjToFormat = (format, date) => {
  const fullMonthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const suffix = ['st', 'nd', 'rd', 'th'];
  const dateObj = date ? new Date(date) : new Date();
  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  let displayValue;
  // eslint-disable-next-line require-jsdoc
  function appendZero(num = 0) {
    if (num < 10) return `0${num}`;

    return num;
  }
  switch (format) {
    case 'dd/mm/yyyy':
      displayValue = `${day}/${month}/${year}`;
      return displayValue;
    case 'dd/mm/yyyy hh:mm:ss':
      const hours = dateObj.getHours();
      const minutes = dateObj.getMinutes();
      const seconds = dateObj.getSeconds();
      displayValue = `${appendZero(day)}/${appendZero(month)}/${appendZero(
        year,
      )} ${appendZero(hours)}:${appendZero(minutes)}:${appendZero(seconds)}`;
      return displayValue;
    case 'ddth monthName yyyy':
      displayValue = `${
        day.toString() +
        ((day >= 11 && day <= 13) || (day % 10) - 1 > 3 || (day % 10) - 1 < 0
          ? suffix[3]
          : suffix[(day % 10) - 1])
      } ${fullMonthNames[month - 1]} ${year.toString()}`;
      return displayValue;
  }
};
export default convertCurrentDateobjToFormat;
